// extracted by mini-css-extract-plugin
export default {"dropdown-hack":"Navbar_dropdown-hack__ysAYj","btn-link":"Navbar_btn-link__5aIpM","navbar":"Navbar_navbar__Srgiu"};